import React from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "@mantine/core"

import { Icon } from "@/components/Icon"

import { useStyles } from "@/components/ProfileTopBar/ProfileTopBar.styles"

export const ProfileTopBar = ({
    className,
    titleAs,
    children,
}: {
    className?: string
    titleAs?: "h1"
    children: React.ReactNode
}) => {
    const { classes, cx } = useStyles()
    const navigate = useNavigate()
    const Title = titleAs || "div"

    return (
        <div className={cx(classes.container, className)}>
            <Button className={classes.goBackButton} onClick={() => navigate(-1)} aria-label="go back">
                <Icon icon="arrow-left" />
            </Button>
            <Title className={classes.title}>{children}</Title>
        </div>
    )
}
